import { User } from '@cgs/data-access';

export const T_ISimpleUserInfoHolder = Symbol('ISimpleUserInfoHolder');
export interface ISimpleUserInfoHolder {
  user: User;
}

export class SimpleUserInfoHolder implements ISimpleUserInfoHolder {
  private _user: User = new User();

  get user(): User {
    return this._user;
  }

  set user(user: User) {
    this._user = user;
  }
}
